import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ReactComponent as LogoIcon } from "../../assets/logo/logo-centralis-gris.svg";
import Button from '../../composants/Button/Button';
import './VerifyEmail.css';

const VerifyEmail: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const location = useLocation();
  
  // Extraire les paramètres de l'URL
  const getParamsFromUrl = () => {
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get('id');
    const hash = searchParams.get('hash');
    const expires = searchParams.get('expires');
    const signature = searchParams.get('signature');
    
    return { id, hash, expires, signature };
  };
  
  const { id, hash, expires, signature } = getParamsFromUrl();

  // Vérification automatique à l'arrivée sur la page si paramètres présents
  useEffect(() => {
    // Vérifier que tous les paramètres nécessaires sont présents
    if (id && hash && expires && signature) {
      // Ne pas lancer la vérification automatiquement, laisser l'utilisateur cliquer sur le bouton
      // handleVerifyEmail();
    } else if (location.search) {
      // Paramètres incomplets
      setError("Le lien de vérification est incomplet ou incorrect. Veuillez vérifier l'URL ou contacter notre support.");
    }
  }, []);

  const handleVerifyEmail = async () => {
    // Vérification des paramètres requis
    if (!id || !hash || !expires || !signature) {
      setError("Paramètres de vérification manquants. Veuillez vérifier le lien reçu par email.");
      return;
    }
    
    setIsLoading(true);
    setError(null);
    
    try {
      // URL correcte pour l'API avec tous les paramètres nécessaires
      const apiUrl = `${process.env.REACT_APP_API_URL}/email/verify/${id}/${hash}?expires=${expires}&signature=${signature}`;
      
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        }
      });
      
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || 'Une erreur est survenue lors de la vérification');
      }
      
      setMessage("Votre adresse email a été vérifiée avec succès !");
      
      // Vérifier si une URL de redirection est présente
      if (data.redirect) {
        setTimeout(() => {
          window.location.href = data.redirect;
        }, 2000);
      } else {
        // Redirection par défaut vers la page de connexion après 3 secondes
        setTimeout(() => {
          navigate('/login');
        }, 3000);
      }
      
    } catch (error) {
      if (error instanceof Error) {
        setError(error.message);
      } else {
        setError("Une erreur inconnue est survenue lors de la vérification");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="verify-email-container">
      <div className="verify-email-card">
        <div className="logo-container">
          <LogoIcon className="logo" />
        </div>
        <h1>Vérification de votre adresse email</h1>
        
        {error && <div className="error-message">{error}</div>}
        {message && <div className="success-message">{message}</div>}
        
        <div className="verify-email-content">
          <p>Veuillez cliquer sur le bouton ci-dessous pour vérifier votre adresse email.</p>
          
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              type="button"
              variant="primary"
              value={isLoading ? "Chargement..." : "Vérifier mon email"}
              size="medium"
              onClick={handleVerifyEmail}
              disabled={isLoading || !!message || !id || !hash}
            />
          </div>
        </div>
        
        {!isLoading && !message && (
          <div className="verify-email-footer">
            <p>Si vous rencontrez des problèmes, veuillez contacter notre support.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default VerifyEmail;